import React from "react";
import Loading from "../svg/loading";
import Text from "../text";
import EditIcon from "../svg/editIcon";

const Loader = props => {
    const {description} = props
    return(
        <div className="page-loading">
            <div className="loader">
            <Loading/>

                <Text type="PARAGRAPH" className="description mt-4 text-center" text={description} />

            </div>
        </div>
    )
}




export default Loader;
Loader.defaultProps = {
    description: 'Loading please wait...'
}
